import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pt-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", {
  class: "anchor fw-bolder mb-5",
  id: "modal-blocking"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#modal-blocking" }),
  /*#__PURE__*/_createTextVNode(" Modal Blocking ")
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "py-5" }, [
  /*#__PURE__*/_createTextVNode(" Use "),
  /*#__PURE__*/_createElementVNode("code", null, ".overlay-block"),
  /*#__PURE__*/_createTextVNode(" class block a modal's content. ")
], -1)
const _hoisted_4 = { class: "py-5" }
const _hoisted_5 = { class: "rounded border p-10" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-primary me-2",
  "data-bs-toggle": "modal",
  "data-bs-target": "#exampleModal"
}, " Launch modal ", -1)
const _hoisted_9 = {
  class: "modal fade",
  id: "exampleModal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_10 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_11 = { class: "modal-content modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h5", {
  class: "modal-title",
  id: "exampleModalLabel"
}, " Modal Title ", -1)
const _hoisted_14 = {
  class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}
const _hoisted_15 = { class: "svg-icon svg-icon-2x" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "modal-body overlay overlay-block" }, [
  /*#__PURE__*/_createTextVNode(" Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, "),
  /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer bg-dark bg-opacity-5" }, [
    /*#__PURE__*/_createElementVNode("div", {
      class: "spinner-border text-primary",
      role: "status"
    }, [
      /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
    ])
  ])
], -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "modal-footer" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-light-primary fw-bold",
    "data-bs-dismiss": "modal"
  }, " Close "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn btn-primary fw-bold"
  }, " Ok ")
], -1)
const _hoisted_18 = { class: "py-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", _hoisted_15, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotune/arrows/arr061.svg" })
                      ])
                    ])
                  ]),
                  _hoisted_16,
                  _hoisted_17
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(`<button
          type="button"
          class="btn btn-primary me-2"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
        >
          Launch modal
        </button>

        <!--begin::Modal Body Overlay-->
        <div
          class="modal fade"
          id="exampleModal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content modal-content">
              <div class="modal-header">
                <h5 class="modal-title" id="exampleModalLabel">Modal Title</h5>

                <!--begin::Close-->
                <div
                  class="btn btn-icon btn-sm btn-active-light-primary ms-2"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span class="svg-icon svg-icon-2x"></span>
                </div>
                <!--end::Close-->
              </div>

              <!--begin::Overlay-->
              <div class="modal-body overlay overlay-block">
                Lorem Ipsum is simply dummy text ...

                <!--begin::Overlay Layer-->
                <div class="overlay-layer bg-dark bg-opacity-5">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <!--end::Overlay Layer-->
              </div>
              <!--end::Overlay-->

              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-light-primary fw-bold"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button type="button" class="btn btn-primary fw-bold">
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
        <!--end::Modal Body Overlay-->`), 1)
        ]),
        _: 1
      })
    ])
  ]))
}